import React, { memo } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { PROFILE_NAV_ITEMS, WALLET_NAV_ITEMS } from "../../constants";
import { SidebarIcon, SidebarItem, SidebarLabel, SidebarRoot } from "../BettoSettingsSidebar/elements";
import { ProfileNavIcons } from "./icons";

const getItemLabel = (item, translate) => (item.labelKey ? translate(item.labelKey) : translate(item.label));

export const BettoProfileNav = memo(({ translate, isWalletPage, currentPath }) => {
	const items = isWalletPage ? WALLET_NAV_ITEMS : PROFILE_NAV_ITEMS;

	return (
		<SidebarRoot aria-label={translate("Profile")}>
			{items.map((item) => (
				<NavLink
					key={item.key}
					to={item.link}
					style={{ textDecoration: "none" }}
					data-testid={item.testId}>
					<SidebarItem as="div" $active={currentPath === item.link} type="button">
						<SidebarIcon>{ProfileNavIcons[item.key]}</SidebarIcon>
						<SidebarLabel>{getItemLabel(item, translate)}</SidebarLabel>
					</SidebarItem>
				</NavLink>
			))}
		</SidebarRoot>
	);
});

BettoProfileNav.displayName = "BettoProfileNav";

BettoProfileNav.propTypes = {
	translate: PropTypes.func.isRequired,
	isWalletPage: PropTypes.bool,
	currentPath: PropTypes.string,
};
